import { FIRE_DEPARTMENT_IDS } from "../../../constants";
import { StaffActivitiesByDescription } from "../../types";

export const staffActivities: StaffActivitiesByDescription = {
  "Idaho Falls Form": {
    parameters: {
      linkUrls: ["https://www.idahofallsidaho.gov/1220/Forms-and-Applications"],
      staffInputs: {
        fees: false,
        documentTypes: {
          report: false,
        },
      },
      includeFireDistricts: [
        {
          id: FIRE_DEPARTMENT_IDS.ID.IDAHO_FALLS,
          name: "Idaho Falls Fire Dept",
        },
      ],
    },
    jurisdictionType: "City/County",
    state: "ID",
  },
};
